import '../../lightgallery/sass/lightgallery.scss';
import '../../lightgallery/js/lightgallery';
import '../../lightgallery/js/lg-thumbnail';
import '../../lightgallery/js/lg-autoplay';
import '../../lightgallery/js/lg-share';

export function applyTo(selector, options) {
    document.querySelectorAll(selector).forEach(function(element) {
        lightGallery(element, options);
    });

    document.addEventListener('openGallery', (e) => {
        console.log(e.detail);
        const div = document.createElement('div');
        lightGallery(div, {
            dynamic: true,
            dynamicEl: e.detail.items,
            index: e.detail.active,
        });
    });
}

